import * as React from "react";
import {InfoBanner} from "@ferry/portal-core";

export class RenewalDocumentsBanner extends React.Component<{}> {

    public render() {
        return <InfoBanner wording={<>Heads up - <b> please read your <span className="link-style">document of insurance</span> along with your <span className="link-style">renewal invitation</span></b></>}/>
    }
}
